/**
 * form関連
 */

export default class Form {
	constructor() {
		this.input = document.querySelectorAll('.input');
		this.input_select = document.querySelectorAll('.input--select');
		this.input_body = document.querySelectorAll('.input__body');
		this.suggest = document.querySelectorAll('.input__suggest');
		this.select_item = document.querySelectorAll('.selectbox-item');

		this.init();
		this.addListeners();
	}

	/**
	 * 初期処理
	 */
	init() {
		for (let i = 0, l = this.input_body.length; i < l; i++) {
			let current = this.input_body[i];
			let front = current.parentNode.querySelector('.input__front');

			// 初期値チェック
			if (current.value) {
				// selectの初期値設定
				if (front) {
					let select_item = current.parentNode.querySelectorAll('.selectbox-item');

					for (let i = 0, l = select_item.length; i < l; i++) {
						let s = select_item[i];
						let d_val = s.getAttribute('data-value');

						s.classList.remove('selectbox-item--current');

						if (d_val === current.value) {
							s.classList.add('selectbox-item--current');
							front.textContent = s.textContent;
						}
					}
				}

				this.input[i].classList.add('input--selected');
			}
		}

		for (let i = 0, l = this.suggest.length; i < l; i++) {
			this.suggest[i].value = '';
		}
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		// bodyイベント追加
		document.body.addEventListener('click', this.selectBlur.bind(this), false);

		// inputイベント追加
		for (let i = 0, l = this.input.length; i < l; i++) {
			this.input[i].addEventListener('click', this.inputOnFocus.bind(this), false);
		}

		// input_bodyイベント追加
		for (let i = 0, l = this.input_body.length; i < l; i++) {
			let current = this.input_body[i];

			current.addEventListener('focus', this.inputOnFocus.bind(this), false);
			current.addEventListener('blur', this.inputOnBlur, false);
		}

		// input_suggestイベント追加
		for (let i = 0, l = this.suggest.length; i < l; i++) {
			this.suggest[i].addEventListener('keydown', this.suggestKeyAction, false);
			this.suggest[i].addEventListener('keyup', this.suggestKeyAction, false);
		}

		// input--selectのイベント伝播止める
		for (let i = 0, l = this.input_select.length; i < l; i++) {
			this.input_select[i].addEventListener('click', e => e.stopPropagation(), false);
		}

		// select選択イベント追加
		for (let i = 0, l = this.select_item.length; i < l; i++) {
			this.select_item[i].addEventListener('click', this.selectBoxClick.bind(this), false);
		}
	}

	/**
	 * フォーカス処理
	 */
	inputOnFocus(e) {
		const _this = e.type === 'focus' ? e.currentTarget.parentNode : e.currentTarget;
		let body = e.type === 'focus' ? _this : _this.querySelector('.input__body');

		if (_this.classList.contains('input--disabled')) return;

		if (!_this.classList.contains('input--select')) {
			for (let i = 0, l = this.input_select.length; i < l; i++) {
				this.input_select[i].classList.remove('input--focus');
			}
		} else {
			body = _this.querySelector('.input__suggest');
		}

		_this.classList.add('input--focus');
		body.focus();
	}

	/**
	 * ブラー処理
	 */
	inputOnBlur() {
		const input = this.parentNode;
		const val = this.value;

		// selectはスルー
		if (input.classList.contains('input--select')) return;

		if (val) return;

		input.classList.remove('input--focus', 'input--selected');
	}

	/**
	 * selectの疑似ブラー処理
	 */
	selectBlur() {
		const input = document.querySelectorAll('.input--select');

		this.selectShowAll();

		for (let i = 0, l = input.length; i < l; i++) {
			input[i].classList.remove('input--focus');
			input[i].querySelector('.input__suggest').value = '';
		}
	}

	/**
	 * suggestキーボード操作
	 */
	suggestKeyAction() {
		const input = this.parentNode;
		const item = input.querySelectorAll('.selectbox-item');
		const val = this.value;

		for (let i = 0, l = item.length; i < l; i++) {
			const current = item[i];
			const val_up = String(val).toUpperCase();
			const item_up = current.textContent.toUpperCase();

			current.classList.remove('selectbox-item--hide');
			if (item_up.indexOf(val_up) < 0) {
				current.classList.add('selectbox-item--hide');
			}
		}
	}

	/**
	 * selectの絞込解除
	 */
	selectShowAll() {
		for (let i = 0, l = this.select_item.length; i < l; i++) {
			this.select_item[i].classList.remove('selectbox-item--hide');
		}
	}

	/**
	 * select選択処理
	 */
	selectBoxClick(e) {
		e.stopPropagation();

		const _this = e.currentTarget;
		const list = _this.parentNode;
		const item = list.querySelectorAll('.selectbox-item');
		const index = Array.prototype.indexOf.call(document.querySelectorAll('.selectbox-list'), list);
		const text = _this.textContent;
		const val = _this.getAttribute('data-value');
		const input = this.input_select[index];
		const input_body = input.querySelector('.input__body');
		const front = input.querySelector('.input__front');

		for (let i = 0, l = item.length; i < l; i++) {
			item[i].classList.remove('selectbox-item--current');
		}
		_this.classList.add('selectbox-item--current');

		front.textContent = text;
		input_body.value = val;
		input.classList.remove('input--focus');
		input.classList.add('input--selected');

		this.selectBlur();
	}
}



// WEBPACK FOOTER //
// ./src/js/module/Form.js